/*
  Haelt die versteckten Angaben im Fragen-Formular aktuell.

  Der Besucher waehlt oft erst eine Variante und stellt dann seine Frage.
  Ohne dieses Skript stuende in der Mail die Artikelnummer, die beim
  Laden der Seite zufaellig aktiv war - also die falsche.

  Quelle ist der Artikelnummer-Absatz des Themes, den das Theme beim
  Variantenwechsel selbst aktualisiert. Damit gibt es nur eine Wahrheit.
*/
(function () {
  function aktualisieren() {
    document.querySelectorAll('[data-hss-frage-sku]').forEach(function (feld) {
      var abschnitt = feld.closest('[id^="shopify-section"]');
      if (!abschnitt) return;

      var sku = abschnitt.querySelector('.product__sku');
      if (sku) {
        // Der sichtbare Absatz enthaelt auch den Vorsatz "Art.-Nr." und
        // einen unsichtbaren Text fuer Screenreader. Beides muss weg.
        var vorsatz = sku.querySelector('.product__sku-vorsatz');
        var text = sku.textContent || '';
        if (vorsatz) text = text.replace(vorsatz.textContent, '');
        text = text.replace(/^\s*SKU:?\s*/i, '').trim();
        if (text) {
          // Der Vorsatz steht mit im Feld, damit ueber dem Feld keine
          // eigene Beschriftung noetig ist.
          var vor = feld.dataset.hssFrageVorsatz || '';
          feld.value = vor ? vor + ' ' + text : text;
        }
      }

      var varianteFeld = abschnitt.querySelector('[data-hss-frage-variante]');
      if (varianteFeld) {
        var gewaehlt = abschnitt.querySelector('variant-selects select');
        if (gewaehlt) {
          varianteFeld.value = gewaehlt.value;
        } else {
          var an = abschnitt.querySelector('variant-selects input[type="radio"]:checked');
          if (an) varianteFeld.value = an.value;
        }
      }
    });
  }

  function start() {
    if (!document.querySelector('[data-hss-frage-sku]')) return;
    aktualisieren();

    // Beim Variantenwechsel laedt das Theme Teile der Seite nach. Wann das
    // fertig ist, steht nicht fest - ein fester Wartewert war zu kurz und
    // schrieb die alte Artikelnummer ins Formular. Deshalb wird die
    // Anzeige beobachtet und erst reagiert, wenn sie sich wirklich
    // geaendert hat.
    document.querySelectorAll('.product__sku').forEach(function (sku) {
      new MutationObserver(function () {
        aktualisieren();
      }).observe(sku, { childList: true, characterData: true, subtree: true });
    });

    // Fuer den Fall, dass das Theme den Absatz komplett austauscht statt
    // seinen Inhalt zu aendern, zusaetzlich nach dem Wechsel nachfassen.
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects')) {
        [200, 700, 1500].forEach(function (ms) {
          setTimeout(aktualisieren, ms);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
